import React, { useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
//import "./printOut/assets/billModal.css";
// import SidebarEtd from '../../../shared/components/SidebarEtd';
// import HeaderEtd from '../../../shared/components/HeaderEtd';
import { FaSearch, FaTrashAlt } from "react-icons/fa";
//import { getLoginInfo } from '../../../shared/utils/storage';
//import { createNotification } from '../../../shared/components/Popup';
import SidebarEtd from "../../../shared/components/SidebarEtd";
import HeaderEtd from "../../../shared/components/HeaderEtd";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
//import "./printOut/assets/bill.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import loadingIcon from '../../../assets/img/loadingElement.gif';
import { searchDocumentFormValidator } from '../../../shared/validators/FormValidator';
import FormControl from "@mui/material/FormControl";
import { getLoginInfo } from '../../../shared/utils/storage';

import AppManagementReusComponent from "../../../shared/hooks/useApplicationManagement";
import { createNotification } from '../../../shared/components/Popup';
import {
  documentSearchApi,
  protectedApi,
} from '../../../shared/services/apiService';
import Lindo from '../../../app/guards/RouteGuard';

const UnlockDocumentComponent = () => {
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [isTableData, setIsTableData] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const navigate = useNavigate();
  const [appInfo, setAppInfo] = useState();
  //const { isLoading } = AppManagementReusComponent();
  const [isDocReset, setIsDocReset] = useState(false);
  const [application, setApplication] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [DocumentNumber, setDocumentNumber] = useState();
  const [searchErrors, setSearchErrors] = useState({});
  const { mgambo } = Lindo();
  useEffect(() => {
    mgambo("FunguaNyaraka");
  }, []);
  const clearData = () => {
    setDocumentNumber("");
    setIsTableData(false);
  };

  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  const handleIseDocResetModal = () => {
    setIsDocReset(true);
  };
  const handleCloseIsDocResetModal = () => {
    setIsDocReset(false);
  };

  /*--------------Search document from Portal-----------------*/
  const searchDocument = async () => {
    const validationErrors = searchDocumentFormValidator(DocumentNumber);
    if (Object.keys(validationErrors).length > 0) {
      setSearchErrors(validationErrors);
      return;
    }
    setSearchErrors({});
    setIsLoading(true);
    const payload = {
      ActionType: "Select",
      ApplicationID: "",
      DocumentNumber: DocumentNumber,
      EndDate: "",
      FirstName: "",
      ReportType: "DocumentManagement",
      StartDate: "",
      Station: getLoginInfo()?.user?.StationID,
      Surname: "",
      UserId: "",
      TerritoryID: getLoginInfo()?.user?.TerritoryID,
      UserName: getLoginInfo()?.user?.Username,
    };

    protectedApi(payload, "reports")
      .then((result) => {
        setIsLoading(false);
        if (result?.code == 1) {
          setAppInfo(result.data[0]);
          setIsTableData(true);
        } else {
          const info = { type: "error", message: result?.message };
          result?.data && createNotification(info)();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  /*--------------View Online Portal-----------------*/
  const resetDocumentFn = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const payload = {
      ActionType: "Delete",
      ApplicationID: "",
      DocumentNumber: DocumentNumber,
      EndDate: "",
      FirstName: "",
      ReportType: "DocumentManagement",
      StartDate: "",
      Station: getLoginInfo()?.user?.StationID,
      Surname: "",
      UserId: "",
      TerritoryID: getLoginInfo()?.user?.TerritoryID,
      UserName: getLoginInfo()?.user?.Username,
    };
    const result = await protectedApi(payload, "reports");
    setIsLoading(false);
    if (result?.code == 1) {
      handleCloseIsDocResetModal();
      setIsTableData(false);
      const info = { type: "success", message: result?.message };
      createNotification(info)();
    } else {
      setIsTableData(false);
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };

  /*----------------Styles-------------------*/
  const styles = {
    td1: {
      paddingTop: "5px",
      paddingBottom: "5px",
      textAlign: "center",
      fontSize: "15px",
      fontWeight: "bold",
      width: "200px",
    },
    td2: {
      paddingTop: "5px",
      paddingBottom: "5px",
      textAlign: "center",
      color: "#850505",
      fontSize: "15px",
      width: "300px",
    },
    td3: {
      paddingTop: "3px",
      paddingBottom: "3px",
      textAlign: "right",
      fontWeight: "bold",
      fontSize: "14px",
      width: "200px",
    },
    td4: {
      paddingTop: "3px",
      paddingBottom: "3px",
      textAlign: "left",
      color: "#850505",
      fontSize: "15px",
      width: "300px",
    },
    td5: {
      paddingTop: "3px",
      paddingBottom: "3px",
      width: "20%",
      textAlign: "center",
      color: "#850505",
    },
    th1: {
      width: "20%",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "14px",
    },
  };

  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <br />
              <div className="card-body">
                <h3 style={{ color: "#c2c2c2" }}>
                  <i>Unlock Document</i>
                </h3>
              </div>
              <div className="row2">
                <div className="col-md-12">
                  <div className="card2">
                    <div className="card-body4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="column"
                              style={{ backgroundColor: "#aaa;" }}
                            >
                              <p>
                                <table>
                                  <tr>
                                    <td colSpan={5}>
                                      <label
                                        className="control-label"
                                        for="FirstName"
                                      >
                                        <b style={{ color: "green" }}>
                                          Search Documents:
                                        </b>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        id="DocumentNumber"
                                        className="form-control"
                                        name="DocumentNumber"
                                        aria-required="true"
                                        placeholder="Document No."
                                        style={{
                                          color: "#850505",
                                          fontSize: "1rem",
                                          width: "320px",
                                        }}
                                        value={DocumentNumber}
                                        onChange={(e) =>
                                          setDocumentNumber(e.target.value)
                                        }
                                      />
                                      {searchErrors.DocumentNumber && (
                                        <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                          {searchErrors.DocumentNumber}
                                        </div>
                                      )}
                                    </td>
                                    <td>&nbsp;&nbsp;&nbsp;</td>
                                    <td>
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={() => searchDocument()}
                                        name="submit"
                                        style={{ height: "35px" }}
                                      >
                                        {loading ? (
                                          "Wait.."
                                        ) : (
                                          <b>
                                            <FaSearch
                                              style={{ fontSize: "15px" }}
                                            />
                                          </b>
                                        )}
                                      </button>
                                    </td>
                                    <td>&nbsp;&nbsp;&nbsp;</td>
                                    <td>
                                      <button
                                        type="clear"
                                        className="btn btn-warning"
                                        name="clear"
                                        onClick={clearData}
                                        style={{ height: "35px" }}
                                      >
                                        <b>
                                          <FaTrashAlt
                                            style={{ fontSize: "15px" }}
                                          />
                                        </b>
                                      </button>
                                    </td>
                                    <td></td>
                                  </tr>
                                </table>
                              </p>
                            </div>
                            <div>&nbsp;&nbsp;&nbsp;</div>
                            <div
                              className="column"
                              style={{ backgroundColor: "#bbb;" }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isTableData && (
                    <div className="card2">
                      <div className="card-body">
                        <div className="container">
                          <table
                            id="myTable"
                            className="table table-striped table-bordered"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "27%" }}>
                                  <b>Full Name</b>
                                </th>
                                <th style={{ width: "13%" }}>
                                  <b>Email</b>
                                </th>
                                <th style={{ width: "13%" }}>
                                  <b>Mobile</b>
                                </th>
                                <th style={{ width: "18%" }}>
                                  <b>Action</b>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {/* <td>
                                  <h4 style={styles.h4}>{appInfo?.FullName}</h4>
                                </td> */}
                                <td>
                                  <h4 style={styles.h4}>
                                    {appInfo?.DocumentNumber}
                                  </h4>
                                </td>
                                <td>
                                  <h4 style={styles.h4}>{appInfo?.Email}</h4>
                                </td>

                                <td>
                                  <h4 style={styles.h4}>{appInfo?.MobileNo}</h4>
                                </td>

                                <td>
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-sm"
                                    name="ViewPass"
                                    value="0002033"
                                    onClick={handleIseDocResetModal}
                                  >
                                    {isLoading ? "Wait.." : "Unlock"}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={isDocReset}
          onHide={handleCloseIsDocResetModal}
          centered
          size="m"
        >
          <form onSubmit={resetDocumentFn}>
            <Modal.Header closeButton>
              <Modal.Title>Unlock document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box
                display="flex"
                justifyContent="center"
                sx={{ "& > :not(style)": { m: 1 } }}
              >
                <div></div>
                <div className="col-md-6">
                  <TextField
                    id="DocumentNumber"
                    label="DocumentNumber"
                    name="DocumentNumber"
                    onChange={(e) => setDocumentNumber(e.target.value)}
                    value={DocumentNumber}
                    fullWidth
                    required
                    disabled
                  />
                </div>
                <div></div>
              </Box>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseIsDocResetModal}
              >
                Clear / Close
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  >
                    Loading..
                  </span>
                ) : (
                  "Unlock"
                )}
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      </body>
    </>
  );
};

export default UnlockDocumentComponent;
